import { uuidv4 } from './helpers';

const debug = false;
const log = (message, ...optionalParams) =>
  debug && console.log('[Timer] ', message, ...optionalParams);

export class PerfectTimer {
  constructor(id = uuidv4(), speed = 1) {
    this.isRunning = false;
    this.startTime = 0;
    this.overallTime = 0;
    this.id = id;
    this.speed = speed;
  }

  _getTimeElapsedSinceLastStart() {
    if (!this.startTime) {
      return 0;
    }

    return (Date.now() - this.startTime) * this.speed;
  }

  addTimeElapsed(durationInMs) {
    this.overallTime = this.overallTime + durationInMs * this.speed;
  }

  setTimeElapsed(durationInMs) {
    this.overallTime = durationInMs * this.speed;
  }

  start() {
    if (this.isRunning) {
      return log('Timer is already running');
    }

    this.isRunning = true;
    this.startTime = Date.now();
  }

  stop() {
    if (!this.isRunning) {
      return log('Timer is already stopped');
    }
    this.isRunning = false;
    this.overallTime = this.overallTime + this._getTimeElapsedSinceLastStart();
    this.startTime = 0; // Reset start time since timer is stopped
  }

  reset() {
    this.overallTime = 0;

    if (this.isRunning) {
      this.startTime = Date.now();
      return;
    }

    this.startTime = 0;
  }

  getTime() {
    if (!this.startTime) {
      return 0;
    }

    if (this.isRunning) {
      return this.overallTime + this._getTimeElapsedSinceLastStart();
    }

    return this.overallTime;
  }

  setStart() {
    this.startTime = Date.now();
  }

  setSpeed(speed) {
    if (speed <= 0) {
      throw new Error('Speed must be greater than 0');
    }

    if (this.isRunning) {
      // Adjust overallTime with current elapsed time at old speed
      this.overallTime = this.getTime();
      // Restart the timer with current time to avoid discontinuity
      this.startTime = Date.now();
    }

    this.speed = speed;
  }
}
